<template>
  <div name="reports">
    <transition name="fade">
      <div class="loading" v-show="loading">
        <span class="fa fa-spinner fa-spin"></span> Loading
      </div>
    </transition>

    <section v-if="errored" class="ml-10">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </section>

    <div v-else>
      <div
        class="grid grid-cols-6 gap-4 w-11/12 mx-auto mb-6 pb-32"
        v-if="componentLoaded"
      >
        <div
          v-for="workout in workouts"
          :key="workout.identifer"
          @click="showWorkout(workout)"
          class="text-center content-center rounded-2xl p-6 cursor-pointer hover:opacity-50"
          v-bind:style="{ backgroundColor: getBackgroundColor(workout) }"
        >
          <div class="icon bg-white rounded-xl w-12 h-12 pt-3 mx-auto">
            <img :src="contentImage(workout)" class="w-6 h-6 mx-auto" />
          </div>
          <h4 class="pt-3 font-bold">{{ workout.title }}
              <i v-if="!shouldDisplay()" class="fas fa-lock text-yellow-500 text-lg pl-2"></i>
          </h4>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HealthService } from "@/services/health.service";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const UpgradeModal = () => import("@/components/upgrade/UpgradeModal.vue");

const noaccess = () => import("@/components/NoAccess.vue");
const dropdown = () => import("@/components/Dropdown.vue");

export default {
  name: "reports",
  mixins: [upgradeMixin],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.loading == false;
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      workouts: [],
    };
  },
  created() {
    this.refresh();
  },
  mounted() {},
  methods: {
    refresh() {
      this.fetchWorkouts();
    },
    fetchWorkouts() {
      HealthService.getWorkouts()
        .then((response) => (this.workouts = response.data.data))
        .catch((err) => {
          console.log("measures " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    showWorkout(workout) {
      if (this.currentUser.isOnFree && !this.currentAccess.healthAccess) {
        return
      } else {
        this.$router.push({
          name: "HealthMeasureWorkout",
          params: { workout: workout },
        });
      }
    },
    contentImage(workout) {
      let value = workout.key_value;
      return require("@/assets/images/health/icons/" + value + ".png");
    },
    getBackgroundColor(workout) {
      if (workout.color_hash != undefined && workout.color_hash.length != 0) {
        const hex = "#" + workout.color_hash;
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);

        return "rgba(" + r + "," + g + "," + b + ",0.5)";
      } else {
        return "#fed7d7";
      }
    },
        shouldDisplay() {
        if (this.currentUser.isOnFree) {
    
            return this.currentAccess.healthAccess;
        } else {
          return true;
        }
    },
  },
  components: {
    dropdown,
    noaccess,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
